module.exports = __webpack_public_path__ + "img/raaseporinlinna-phone.06bb646e.jpg";